"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Container = ({ insideContainer, children, custoObjectInfo, }) => {
    let cssClassName = '';
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        cssClassName = `${cssClassName}custo-editable`;
    }
    const renderRow = () => {
        return (react_1.default.createElement("div", { className: `${cssClassName} row` },
            editModal && (react_1.default.createElement("div", { className: 'editable-button', onClick: editModal }, "MC")),
            children));
    };
    if (!!insideContainer) {
        return (react_1.default.createElement("div", { className: `${cssClassName} container` }, renderRow()));
    }
    return renderRow();
};
exports.default = Container;
//# sourceMappingURL=index.js.map